import { useQuery } from "@tanstack/react-query";
import { Address } from "viem";
import { useWeb3 } from "./use-web3";

export function useCrossChainMultisig() {
  const { crossChainMultisig } = useWeb3();

  const { data, isLoading, error } = useQuery({
    queryKey: ["ccm"],
    queryFn: async () => {
      if (!crossChainMultisig) return;

      const threshold = await crossChainMultisig.getConfirmationThreshold();
      const signers = (await crossChainMultisig.getSigners()).map(s =>
        s.toLowerCase(),
      ) as Address[];

      return {
        threshold,
        signers,
      };
    },
    enabled: !!crossChainMultisig,
    retry: 3,
  });

  return {
    threshold: data?.threshold,
    signers: data?.signers,
    isLoading,
    error: error as Error | null,
  };
}
